import * as yup from "yup";
import { $enum } from "ts-enum-util";

import {
  CustomerBranchFilterDefault,
  CustomerBranchFilterType
} from "../../api/products.api";

export const createProductReplacementSchema = yup.object().shape({
  replacements: yup.array().of(
    yup.object().shape({
      fromProductId: yup.number().required("Product to be replaced is required"),
      toProductId: yup.number().required(("Replacement Product is required"))
    })),
  type: yup.string().oneOf($enum(CustomerBranchFilterDefault).getValues()).required("Product fields are required"),
  orderTypes: yup.array().of(yup.string().oneOf([
    "scheduled",
    "bulk",
    "adhoc"
  ])).required("Order Types are required"),
  filters: yup.array().of(yup.object().shape({
    customerId: yup.number().nullable(),
    branchId: yup.number().nullable(),
    filterType: yup.string().oneOf($enum(CustomerBranchFilterType).getValues()).required("Filter type is required")
  })),
  effectOrders: yup.object().shape({
    startDate: yup
      .date()
      .label("Start date")
      .required("Start date is required"),
    endDate: yup
      .date()
      .label("End date")
      .when("startDate", (startDate: Date, schema: yup.DateSchema) => {
        if (startDate) {
          return schema.min(startDate);
        } else {
          return schema;
        }
      })
  }),
  effectLists: yup.boolean().required()
});
